import {combineReducers} from 'redux';
import {AdminSignInReducer} from './adminSignIn'
import {AdminAuthRiderReducer} from './aminAuthReducer';
import {codeVerifyAdminReducer} from './codeVerifyReducer'
const reducer = combineReducers({
   AdminSignInReducer,AdminAuthRiderReducer,codeVerifyAdminReducer
    });
    
    export default reducer;
